import React from 'react';

const TONE_CLASSES = {
  neutral: 'border-white/10 bg-white/5 text-white/60',
  success: 'border-emerald-400/30 bg-emerald-500/10 text-emerald-100',
  successSubtle: 'border-emerald-400/20 bg-emerald-500/5 text-emerald-100',
  warning: 'border-amber-400/35 bg-amber-500/15 text-amber-100',
  danger: 'border-rose-400/35 bg-rose-500/15 text-rose-100',
  info: 'border-sky-400/30 bg-sky-500/10 text-sky-100',
};

export default function StatusPill({
  label,
  tone = 'neutral',
  className = '',
  tabularNums = false,
}) {
  if (label == null || label === '') return null;
  const toneClass = TONE_CLASSES[tone] || TONE_CLASSES.neutral;
  return (
    <span
      className={[
        'shrink-0 inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap',
        toneClass,
        tabularNums ? 'tabular-nums' : '',
        className,
      ].filter(Boolean).join(' ')}
    >
      {label}
    </span>
  );
}
